import React from 'react';

class HeaderBrandingCapsule extends React.Component {

    constructor(props) {

        super();
        this.state = {
            headerLogoUrl: props.headerLogoUrl,
            headerBackgroundColor: props.headerBackgroundColor,
            buttonColor: props.buttonColor,
            buttonHoverColor: props.buttonHoverColor
        };

        this.fieldUpdateMethods = {
            headerLogoUrl: props.onHeaderLogoUrlUpdated,
            headerBackgroundColor: props.onHeaderBackgroundColorUpdated,
            buttonColor: props.onButtonColorUpdated,
            buttonHoverColor: props.onButtonHoverColorUpdated
        };

        this.onKeyPressedGen = this.onKeyPressedGen.bind(this);
        this.onClickGen = this.onClickGen.bind(this);
    }

    onKeyPressedGen(fieldName) {
        return (e) => {
            return this.setState({ [fieldName]: e.target.value });
        };
    }

    onClickGen(fieldName) {
        return (e) => {
            return this.fieldUpdateMethods[fieldName](this.state[fieldName]);
        };
    }

    render() {

        return (
            <div style={{ marginTop: '3%', marginBottom: '3%' }} className="col-12">
                <div className="row">
                    <div className="col-12">
                        <span className="text-left">
                            <strong>Header Branding</strong>
                        </span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div style={{ paddingLeft: '3%' }}>
                            <em>Header Logo URL</em>
                        </div>
                        <div className="row">
                            <div className="col-10">
                                <input type="text" className="form-control" value={this.state.headerLogoUrl || ""} onChange={this.onKeyPressedGen('headerLogoUrl')} />
                            </div>
                            <div className="col-2">
                                <button className="btn btn-small btn-default" onClick={this.onClickGen('headerLogoUrl')}><i className="fas fa-check"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div style={{ paddingLeft: '3%' }}>
                            <em>Header Background Color</em>
                        </div>
                        <div className="row">
                            <div className="col-10">
                                <input type="text" className="form-control" placeholder="#RRGGBB" value={this.state.headerBackgroundColor || ""} onChange={this.onKeyPressedGen('headerBackgroundColor')} />
                            </div>
                            <div className="col-2">
                                <button className="btn btn-small btn-default" onClick={this.onClickGen('headerBackgroundColor')}><i className="fas fa-check"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div style={{ paddingLeft: '3%' }}>
                            <em>Button Color</em>
                        </div>
                        <div className="row">
                            <div className="col-10">
                                <input type="text" className="form-control" placeholder="#RRGGBB" value={this.state.buttonColor || ""} onChange={this.onKeyPressedGen('buttonColor')} />
                            </div>
                            <div className="col-2">
                                <button className="btn btn-small btn-default" onClick={this.onClickGen('buttonColor')}><i className="fas fa-check"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div style={{ paddingLeft: '3%' }}>
                            <em>Button Hover Color</em>
                        </div>
                        <div className="row">
                            <div className="col-10">
                                <input type="text" className="form-control" placeholder="#RRGGBB" value={this.state.buttonHoverColor || ""} onChange={this.onKeyPressedGen('buttonHoverColor')} />
                            </div>
                            <div className="col-2">
                                <button className="btn btn-small btn-default" onClick={this.onClickGen('buttonHoverColor')}><i className="fas fa-check"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default HeaderBrandingCapsule;
